<!--
 * @Author: zl
 * @Date: 2022-09-01 09:10:20
 * @LastEditTime: 2022-09-01 09:54:14
 * @LastEditors: zl
 * @Description: 资料目录维护
-->
<template>
	<div class="projectData-layout filter-layout">
		<div class="filter-box">
			<div class="primary-layout">
				<div class="primary-header">
					<div class="left-text">
						项目资料目录维护
						<el-tooltip placement="right"
									effect="light">
							<div slot="content">
								<p>项目资料目录维护:管理员创建项目资料目录，运营人员</p>
								<p class="mt10">上传资料时，可选择相应资料清单上传资料.</p>
							</div>
							<svg-icon class="ml5"
									  icon-class="wenhao"></svg-icon>
						</el-tooltip>
					</div>
					<div class="btnGroups">
						<el-input v-model="searchName"
								  placeholder="请输入目录名称"
								  size="small"
								  class="w300"
								  @keyup.enter.native="doSearch">
							<template slot="append">
								<el-button type="primary"
										   size="small"
										   class="btn-blue"
										   @click="doSearch">查询</el-button>
							</template>
						</el-input>
						<el-button type="success"
								   size="small"
								   class="btn-success ml10"
								   icon="el-icon-refresh"
								   @click="refresh"></el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="filter-content primary-layout">
			<div class="primary-header">
				<div></div>
				<div class="btnGroups">
					<el-button type="primary"
							   size="small"
							   v-if="roleBtns.includes('unlock')"
							   @click="isDisabled = !isDisabled">
						{{ isDisabled ? '解锁' : '锁定' }}
					</el-button>
					<el-button type="primary"
							   size="small"
							   :disabled="isDisabled"
							   v-if="roleBtns.includes('save')"
							   @click="doSave">保存</el-button>
					<!-- <el-button size="small"
							   disabled>导出Excel</el-button> -->
				</div>
			</div>
			<div class="primary-content">
				<vxe-table align="center"
						   auto-resize
						   border
						   :data="fileData"
						   resizable
						   row-id="treeId"
						   ref="xTable"
						   height="100%"
						   class="xTable"
						   highlight-current-row
						   highlight-hover-row
						   :loading="loading"
						   show-overflow="tooltip"
						   show-header-overflow="tooltip"
						   :tree-config="{children: 'children', expandAll: true}"
						   :edit-config="{ trigger: 'click', mode: 'cell', activeMethod:activeRowMethod }">
					<vxe-table-column type="seq"
									  title="序号"
									  width="70"></vxe-table-column>
					<vxe-table-column field="sname"
									  title="目录名称"
									  tree-node
									  header-align="center"
									  align="left">
						<template v-slot="{ row, rowIndex }">
							<el-input v-model.trim="row.sname"
									  v-if="!row.id"
									  size="small"
									  class="is-required"
									  :disabled="isDisabled"
									  maxlength="30"
									  show-word-limit
									  placeholder="请输入目录名称"></el-input>
							<div v-else>
								<span class="vxe-cell--label">
									<i v-if="row.level < 3"
									   class="el-icon-folder-opened mr5"></i>
									<i v-else
									   class="el-icon-tickets mr5"></i>{{ row.sname }}
								</span>
							</div>
						</template>
					</vxe-table-column>
					<!-- <vxe-table-column field="type"
									  title="资料应用"
									  width="">
						<template v-slot="{ row }">
							<el-select v-model="row.type"
									   placeholder="请选择资料应用"
									   size="small"
									   :disabled="isDisabled"
									   v-if="row.level == 2 || row.level == 3">
								<el-option :value="0"
										   label="项目"></el-option>
								<el-option :value="1"
										   label="标段"></el-option>
							</el-select>
							<div v-else>-</div>
						</template>
					</vxe-table-column> -->
					<vxe-table-column field="remark"
									  title="备注说明"
									  width="">
						<template v-slot="{ row }">
							<el-input v-model.trim="row.remark"
									  v-if="row.level == 2 || row.level == 3"
									  :disabled="isDisabled"
									  placeholder="请输入备注说明"
									  size="small"></el-input>
							<div v-else>-</div>
						</template>
					</vxe-table-column>
					<vxe-table-column field="upFlag"
									  title="是否需要上传"
									  width="140">
						<template v-slot="{ row }">
							<vxe-switch v-model="row.upFlag"
										open-label="是"
										:open-value="1"
										close-label="否"
										disabled
										:class="{ opacityHide: isDisabled }"
										:close-value="0"
										@click.native.prevent="handleSwitch(row)"></vxe-switch>
						</template>
					</vxe-table-column>
					<vxe-table-column field="sort"
									  title="顺序"
									  width="130">
						<template #default="{ row }">
							<div v-if="row.pid != 0">
								<el-button type="primary"
										   size="mini"
										   :disabled="dealDisabled('up', row)"
										   icon="el-icon-arrow-up"
										   @click="moveSort('up', row)"></el-button>
								<el-button type="primary"
										   size="mini"
										   :disabled="dealDisabled('down', row)"
										   icon="el-icon-arrow-down"
										   @click="moveSort('down', row)"></el-button>
							</div>
							<div v-else>-</div>
						</template>
					</vxe-table-column>
					<vxe-table-column title="操作"
									  width="100">
						<template #default="{ row }">
							<el-button type="text"
									   icon="el-icon-plus"
									   :disabled="isDisabled"
									   v-show="row.level != 3"
									   @click="addFile(row)"
									   title="添加下一级"></el-button>
							<el-button type="text"
									   icon="el-icon-delete"
									   :disabled="isDisabled || row.isDelete == '1'"
									   v-show="row.pid != '0'"
									   :class="{ ml0: row.level == 3 }"
									   @click="deleteFile(row)"
									   title="删除"></el-button>
						</template>
					</vxe-table-column>
				</vxe-table>
			</div>
		</div>
	</div>
</template>

<script>
import * as API from '@/api/modules/ProjectDataMaintenance'
import { mapState } from 'vuex'
export default {
	name: 'ProjectDataMaintenance',
	data() {
		return {
			searchName: '', //搜索
			fileData: [], //资料数据
			defaultData: [], //接口返回的原始数据
			loading: false, //表格加载
			isDisabled: true, //是否可编辑
		}
	},
	created() {
		this.getFileData('1')
	},
	methods: {
		// 查询资料清单模板
		getFileData(data) {
			if (data != '1') {
				this.loading = true
			}
			this.defaultData = []
			this.fileData = []
			API.selectTemplateFile({})
				.then((res) => {
					if (res.data.length != 0) {
						res.data.forEach((item, index) => {
							this.fileData.push(item)
							// 备份数据
							this.defaultData.push(item)
						})
						setTimeout(() => {
							this.fileData[0].children.forEach((item, index) => {
								// 将树里面的最顶级的上移禁用 最下级的下移禁用
								if (index == 0) {
									item.up = 'disabled'
								}
								if (
									index ==
									this.fileData[0].children.length - 1
								) {
									item.down = 'disabled'
								}
							})
							this.loading = false
							this.$refs.xTable.setAllTreeExpand(true)
						}, 1000)
						if (this.searchName != '') {
							this.doSearch()
						}
					} else {
						this.loading = false
					}
				})
				.catch(() => {
					this.fileData[0].children = []
					this.loading = false
				})
		},

		// 添加层级
		addFile(data) {
			let _node = {
				pid: '',
				sort: this.dealSort(data),
				treeId: data.treeId + (data.children.length + 1),
				sname: '',
				// type: 0,
				upFlag: 0,
				level: data.level + 1,
				children: [],
			}
			data.children.push(_node)
			// 设置展开
			this.$refs.xTable.setTreeExpand(data, true)
			// 设置选中
			this.$refs.xTable.setActiveRow(_node)
		},

		// 删除层级
		async deleteFile(data) {
			// 找到父节点
			let _parent = ''
			// 如果是新增的 没有id
			if (!data.id) {
				_parent = this.$utils.findTree(
					this.fileData,
					(x) => x.treeId === data.treeId.substr(0, 19)
				)
				this.deleteMethod(_parent.item, data)
				return
			} else {
				_parent = this.$utils.findTree(
					this.fileData,
					(x) => x.treeId === data.pid
				)
			}

			// 已经存在的 接口删除
			this.loading = true
			let status = await this.$deleteConfirm('是否确认删除该结构？', true)
			if (status) {
				API.deleteTemplateFile({
					id: data.id,
				})
					.then((res) => {
						this.deleteMethod(_parent.item, data, 'no')
						this.$refs.xTable.setAllTreeExpand(false)
						setTimeout(() => {
							this.doSave()
						}, 100)
					})
					.catch(() => {
						this.loading = false
					})
			} else {
				this.$message.info('操作取消')
				this.loading = false
			}
		},

		// 删除公共函数（有 id 和 没id）
		deleteMethod(_parent, row, type) {
			if (_parent) {
				// 删除节点
				_parent.children.splice(
					_parent.children.findIndex((x) => x.treeId === row.treeId),
					1
				)
				if (type != 'no') {
					this.loading = false
				}
			}
		},

		// 处理排序
		dealSort(data) {
			let sort = ''
			if (data.pid == '0') {
				let obj = this.fileData[0].children
				if (obj.length > 0) {
					sort = obj[obj.length - 1].sort + 1
				} else {
					sort = 1
				}
			} else {
				if (data.children.length > 0) {
					sort = data.children[data.children.length - 1].sort + 1
				} else {
					sort = 1
				}
			}
			return sort
		},

		// 处理禁用
		dealDisabled(type, data) {
			// 先判断有没有解锁
			if (this.isDisabled) {
				return true
			} else {
				// 二级中的的第一个禁止上移 最后一个禁止下移
				if (type == 'up') {
					if (data.up && data.up == 'disabled') {
						return true
					}
				} else {
					if (data.down && data.down == 'disabled') {
						return true
					}
				}
			}
			return false
		},

		// 保存
		doSave() {
			this.loading = true
			// 克隆从接口获取的参数
			let params = this.$utils.clone(this.fileData, true)
			// 判断目录名称是否填写
			let requireSname = this.$utils.filterTree(
				this.fileData,
				(x) => x.sname === ''
			)
			if (requireSname.length > 0) {
				this.$message.warning('目录名称为必填项!')
				this.loading = false
				return
			}
			API.saveOrUpdateTemplateFile({
				allList: params,
			})
				.then((res) => {
					this.getFileData()
				})
				.catch(() => {
					this.loading = false
				})
		},

		// 移动顺序
		async moveSort(type, data) {
			if (!data.id) {
				this.$message.error('新增的节点请保存后在移动顺序！')
				return
			}
			let status = await this.$deleteConfirm('是否确认要移动顺序？', true)
			if (status) {
				// 找到自己的下标
				let _index = this.$utils.findTree(
					this.fileData,
					(x) => x.treeId == data.treeId
				).index
				// 找到父节点
				let pObj = this.$utils.findTree(
					this.fileData,
					(x) => x.id == data.pid
				).item
				let moveList = []
				// 获取移动的两个元素
				moveList = this.dealIndex(type, _index, pObj)
				// 接收到的moveList 不存在就return
				if (!moveList) {
					return
				}
				// 拷贝moveList
				let copyObj = this.$utils.clone(moveList, true)
				// 将要切换顺序的节点的 sort 切换
				moveList[0].sort = copyObj[1].sort
				moveList[1].sort = copyObj[0].sort
				this.loading = true
				API.upOrDownTemplateFile({
					moveList,
				})
					.then((res) => {
						this.doSave()
					})
					.catch(() => {
						this.loading = false
					})
			} else {
				this.$message.info('操作取消！')
			}
		},

		// 判断节点是不是最上面或者最下面
		dealIndex(type, _index, pObj) {
			let moveList = []
			if (type == 'up') {
				// 像上移 如果已经是最上面的 则不能移动
				if (_index == 0) {
					this.$message.error(
						'该节点以位于当前父节点下所有节点的最上面！'
					)
					return
				}
				// 上移将当前下标的元素 和 前一个元素加到 movelist
				moveList = [pObj.children[_index], pObj.children[_index - 1]]
			} else {
				// 像下移 如果已经是最下面的 则不能移动
				if (!pObj.children[_index + 1]) {
					this.$message.error(
						'该节点以位于当前父节点下所有节点的最下面！'
					)
					return
				}
				// 下移将当前下标的元素 和 后一个元素加到 movelist
				moveList = [pObj.children[_index], pObj.children[_index + 1]]
			}
			return moveList
		},

		// 搜索
		doSearch() {
			let filterName = this.searchName.trim()
			this.fileData = []
			this.loading = true
			if (filterName) {
				let options = { children: 'children' }
				let searchProps = ['sname']

				// 树形显示
				this.fileData = this.$utils.searchTree(
					this.defaultData,
					(item) =>
						searchProps.some(
							(key) => item[key].indexOf(filterName) > -1
						),
					options
				)
				this.removeDis(this.fileData)
				// 搜索之后默认展开所有子节点
				this.$nextTick(() => {
					this.loading = false
					this.$refs.xTable.setAllTreeExpand(true)
				})
			} else {
				this.fileData = this.defaultData

				// 搜索之后默认展开所有子节点
				this.$nextTick(() => {
					this.loading = false
					this.$refs.xTable.setAllTreeExpand(true)
				})
			}
		},

		// 重置
		refresh() {
			this.searchName = ''
			this.getFileData()
		},

		// 是否必传change事件
		async handleSwitch(data) {
			if (this.isDisabled) {
				return
			}
			let status = await this.$deleteConfirm(
				'此操作将改变开关状态，是否确认',
				true
			)
			if (status) {
				data.upFlag == 0 ? (data.upFlag = 1) : (data.upFlag = 0)
				this.$message.success('操作完成！')
			} else {
				this.$message.info('操作取消！')
			}
		},

		// 过滤出来的移除disabled
		removeDis(data) {
			if (data.length > 0) {
				data[0].children.forEach((item) => {
					if (item.up) {
						this.$delete(item, 'up')
					}
					if (item.down) {
						this.$delete(item, 'down')
					}
				})
			}
		},

		// 单元格是否可以编辑
		activeRowMethod({ row, column }) {
			return !this.isDisabled
		},

		inputChange(data, index) {
			console.log(data)
			console.log(index)
		},
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
}
</script>

<style scoped lang="less">
.projectData-layout {
	padding: 30px 20px 30px 20px;
	.filter-box {
		padding-bottom: 15px;
	}
	.primary-header {
		height: 48px;
	}
	.vxe-switch.is--disabled {
		opacity: 1;
		/deep/ .vxe-switch--button {
			cursor: pointer !important;
		}
	}
	/deep/ .is--on {
		.vxe-switch--button {
			background-color: #409eff !important;
		}
	}
	.search-area {
		display: flex;
	}
	.left-text {
		font-size: 16px;
	}
	.ml0 {
		margin-left: 0 !important;
	}
	.w300 {
		/deep/ .el-input__inner {
			width: 300px !important;
		}
		.el-button {
			height: 32px !important;
			padding: 9px 20px;
		}
	}
	.xTable {
		/deep/ .vxe-tree-cell {
			.is-required {
				display: flex;
				align-items: center;
				&:before {
					content: '*';
					color: #f56c6c;
					margin-right: 4px;
				}
			}
		}
	}
}
</style>
 